import React from "react";
import HorizontalCard from "./HorizontalCard";

const Why = () => {
    return (
        <div>
            <div className="flex justify-center items-start">
                <h1 className="text-2xl font-bold">Unternehmen</h1>
            </div>
            <div className="flex flex-col items-center space-y-1 lg:space-y-5 px-1 sm:px-4 md:px-6 lg:px-8 xl:px-10">
                <HorizontalCard heading={"Ihr starker Partner für die Transformation von Energiesystemen"} title="ubion ist ein führender Partner im Bereich des Energiemanagements und
                    kombiniert fundierte Datenintegration mit innovativer Analyse, um Unternehmen bei der
                    zukunftssicheren
                    Transformation ihrer Energiesysteme zu unterstützen." icon={"images/network.jpg"} alt={"Netzwerk"}
                                reverse={true}/>
                <HorizontalCard heading={"Maßgeschneiderte Produkte und Lösungen für integriertes Energiemanagement"}
                                title="Aus dem Ubineum-Verbund hervorgegangen,
                    bietet ubion maßgeschneiderte Produkte, Beratungsleistungen und modulare SaaS-Lösungen,
                    die eine automatische Erfassung und Integration von Energiedaten und Energieflüssen aus
                    unterschiedlichsten Quellen, wie Sensoren, Smart Metern und Gebäudeautomationssystemen, ermöglichen.
                    Zusätzlich bietet ubion ein umfassendes Incident-Management, um Probleme frühzeitig zu erkennen und
                    schnell zu beheben." icon={"images/technology.jpg"} alt={"Technologie, Datenanalyse"}/>
                <HorizontalCard heading={"Technologieoffenheit und Sicherheit für modernes Energiemonitoring"} title=" Mit einem technologieoffenen Ansatz und tiefem Systemverständnis setzt ubion neue Maßstäbe im
                    Energiemonitoring. Die flexiblen, skalierbaren SaaS-Architekturen und sicheren Lösungen helfen
                    Unternehmen, ihre sensiblen Energiedaten zu schützen und gleichzeitig eine effiziente Verwaltung
                    komplexer Energiesysteme zu gewährleisten. Dabei wird eine ganzheitliche Basis aus Forschung,
                    Entwicklung und Umsetzung genutzt, um anspruchsvolles Energiemonitoring und vollständige
                    Systemintegrationen auf höchstem Innovationsniveau zu entwickeln." icon={"images/pv.jpg"}
                                alt={"PV-Anlage"}
                                reverse={true}/>
                <HorizontalCard
                    heading={"Die Vision von ubion: Effiziente Energiesysteme für eine erfolgreiche Zukunft"}
                    title="Die Vision von ubion ist eine Welt, in der das volle Potenzial von Energiesystemen effizient genutzt
                    wird, um die Lebensqualität der Menschen zu verbessern und Ressourcen effizient zu nutzen.
                   Mit unseren Lösungen machen wir Energiedaten transparent und nachverfolgbar, unterstützen Unternehmen
                   bei der Erfüllung aktueller Compliance-Anforderungen und steigern ihre Wettbewerbsfähigkeit.
                   Dank modernster Technologie ermöglichen wir einen effizienten Energieeinsatz, senken Kosten und
                   bieten neue Wachstumschancen. So vereinen wir Leistungsfähigkeit und Innovation, um individuelle
                   Herausforderungen zu meistern und die Energiebranche maßgeblich voranzubringen."
                    icon={"images/wind.jpg"} alt={"Windenergie"}/>
            </div>
            {/*</div>*/}
        </div>
    )
}
export default Why;
